export enum FairGameDialogs {
  FAIR_GAME_DIALOG = 'FAIR_GAME_DIALOG',
}
